import { createFileRoute, useNavigate, redirect } from '@tanstack/react-router';
import { ChildStep } from '../features/rsvp/steps/ChildStep';
import { PageShell } from '../features/rsvp/PageShell';
import { useRsvpFlow } from '../features/rsvp/useRsvpFlow';

export const Route = createFileRoute('/rsvp/child')({
  beforeLoad: async () => {
    throw redirect({ to: '/' });
  },
  component: ChildPage,
});

function ChildPage() {
  const navigate = useNavigate();
  const f = useRsvpFlow();

  const onBack = () =>
    navigate({ to: f.children.length > 0 ? '/rsvp/roster' : '/' });

  const onContinue = async () => {
    if (f.draft.status === 'coming') {
      navigate({ to: '/rsvp/fighter' });
    } else {
      if (await f.commitDraft()) navigate({ to: '/rsvp/roster', replace: true });
    }
  };

  return (
    <PageShell globalError={f.globalError}>
      <ChildStep
        key={f.children.length}
        draft={f.draft}
        onChange={f.setDraft}
        parent={f.parent}
        onParentChange={f.setParent}
        parentLocked={f.parentLocked}
        submitting={f.submitting}
        onBack={onBack}
        onContinue={onContinue}
      />
    </PageShell>
  );
}
